import { AppSettingsAdapter, Vehicle } from '@agilox/common';
import { MaasCostPeriod } from '../../pages/maas/models/maas-cost-period.interface';
import { MyAppSettings } from '../interfaces/my-app-settings.interface';

export class MyAppSettingsAdapter implements AppSettingsAdapter<MyAppSettings> {
	defaults(id: string): MyAppSettings {
		return {
			id,
			onboarding: {
				myWatched: false,
			},
			maasOverview: {
				vehicles: [],
				period: null,
			},
		};
	}

	parse(id: string, raw: unknown): MyAppSettings {
		const settings = raw as any;

		const vehicles = Array.isArray(settings?.maasOverview?.vehicles)
			? (settings.maasOverview.vehicles as Vehicle[])
			: [];
		const period = vehicles.length
			? ((settings?.maasOverview?.period as MaasCostPeriod | null) ?? null)
			: null;
		const maasOverview = { vehicles, period };

		if (settings?.onboarding?.version !== undefined) {
			const alreadyWatched = settings.onboarding.version === 2;
			return {
				id,
				onboarding: {
					myWatched: alreadyWatched,
				},
				maasOverview,
			};
		}

		return {
			id,
			onboarding: {
				myWatched: settings?.onboarding?.myWatched ?? false,
			},
			maasOverview,
		};
	}

	toPayload(settings: MyAppSettings): unknown {
		return {
			onboarding: {
				myWatched: settings.onboarding.myWatched,
			},
			maasOverview: {
				vehicles: settings.maasOverview.vehicles,
				period: settings.maasOverview.period,
			},
		};
	}
}
